<template>
  <v-container 
    v-if="config"
    fluid
    style="padding: 0 !important;min-height:calc(100vh);background-color: blue;"
    :style="{ backgroundColor: selectedMenu ? selectedMenu.BGColorContent : config.BGColorContent }"
  >
    <select-locale
      v-if="config && config.Languages && !onlyContent"
      :languages="config.Languages.split(',')"
      :locale="locale"
      :bgColor="selectedMenu ? selectedMenu.BGColor : config.BGColor"
      :color="selectedMenu && selectedMenu.Image ? 'white' : selectedMenu ? selectedMenu.TextColor : config.Color"
    />
    <v-row dense v-if="!onlyContent">
      <v-col
        v-if="selectedMenu"
        cols="12"
        style="padding:0;"
        @click="handleBack"
        class="shadow-card-header"
      >
      <div
        style="position: fixed; top: 10px; left: 5px;z-index: 100;"
      >
          <v-btn
            fab
            small
            elevation="0"
            :key="selectedMenu.ID"
            icon
            @click.stop.prevent="handleBack"
            :color="selectedMenu.Image ? 'white' : selectedMenu ? selectedMenu.TextColor : config.Color"
          >
            <v-icon style="text-shadow: 1px 1px gray;">mdi-arrow-left</v-icon>
          </v-btn>
      </div>
        <v-toolbar
          :prominent="prominent"
          :key="selectedMenu.ID"
          elevation="0"
          style="z-index:102;"
          :style="{ backgroundColor: checkIsMenuColor(selectedMenu, barNoImage) ? selectedMenu.BGColor : null,
                    backgroundImage: !checkIsMenuColor(selectedMenu, barNoImage) && selectedMenu.Image ? `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.6)), url(${selectedMenu.Image})` : null,
                    backgroundPosition: 'center center',
          }"
          dark
        >
          <!--v-btn
            fab
            small
            elevation="0"
            style="top:10px;position:fixed;z-index:100"
            :key="selectedMenu.ID"
            icon
            @click.stop.prevent="handleBack"
            :color="selectedMenu.Image ? null : selectedMenu ? selectedMenu.TextColor : config.Color"
          >
            <v-icon style="text-shadow: 1px 1px gray;">mdi-arrow-left</v-icon>
          </v-btn-->

          <v-toolbar-title
            :style="{ 
              color: checkIsMenuColor(selectedMenu) ? selectedMenu.TextColor : null,
              fontSize: `${selectedMenu.FontSize}px`,
              fontFamily: selectedMenu.Font,
              padding: prominent ? '0 0 10px 35px' : '10px 30px 10px 35px'
            }"
            style="white-space: unset !important;line-height:1;"
          >
            {{getTranslation(selectedMenu.Name, locale, selectedMenu.TextFormat)}}
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <allergens-filter v-if="allergenFilters"  style="z-index: 101 !important;" />

          <!--v-btn icon>
            <v-icon>mdi-export</v-icon>
          </v-btn-->
        </v-toolbar>
      </v-col>
      <v-col
        v-else
        cols="12"
        style="padding:0;"
      >
      <div
        v-if="back"
        style="position: fixed; top: 15px; left: 5px;z-index: 100;"
      >
          <v-btn
            small
            text
            elevation="0"
            @click.stop.prevent="handleBackDomain"
            :color="config.Color"
          >
          <v-icon style="text-shadow: 1px 1px gray;">mdi-arrow-left</v-icon> <span style="text-shadow: 1px 1px gray;">
          {{$t('common.back', locale)}}
          </span>
          </v-btn>
      </div>
    <v-expansion-panels>
      <v-expansion-panel>
        <main-menu-header
          :isDesignByCards="true"
          :isTotem="isTotem"
          v-if="!isTotem"
        />
      </v-expansion-panel>
    </v-expansion-panels>
        <dish-orders-cart
          v-if="config && !isTotem"
          :config="config"
          :locale="locale"
        />
      </v-col>
      <!--v-col
        v-if="selectedMenu"
        cols="12"
        :key="selectedMenu.ID"
        style="padding: 0 10px;"
        :style="{ backgroundColor: selectedMenu.BGColorContent }"
      >
        <v-breadcrumbs 
          :items="prepareBreadcrumbs(selectedMenu, locale)" 
          style="padding: 0;"
          :style="{ color: selectedMenu.ColorContent }"
        >
          <template v-slot:divider>
           / 
          </template>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              @click="prepareMenusByPath(item.ID)"
              :disabled="item.ID === selectedMenu.ID"
            >
            <small>
              {{ item.Name.toUpperCase() }}
            </small>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col-->
    </v-row>
    <v-row 
      v-if="selectedMenu && !selectedMenu.Menus"
      dense 
    >
      <v-col 
        cols="12"
        style="padding:0;min-height:100%;"
        :style="{ 
          paddingLeft: `${180}px`, 
          backgroundColor: selectedMenu.BGColorContent, 
          paddingTop: allergenFilters ? '20px' : '0' 
        }"
      >
        <custom-content
          :id="selectedMenu.ID"
          :customBGColorContent="selectedMenu.BGColorContent"
          :customTextColorContent="selectedMenu.TextColorContent"
          :style="{ width: `${sizeW}px` }"
        />
      </v-col>
    </v-row>
    <v-row 
      v-else 
      dense 
      style="padding: 50px;"
    >
      <v-col
        v-for="(card, index) in selectedMenu ? selectedMenu.Menus.filter(x => !x.HideMobile) : menus.filter(x => !x.HideMobile)"
        :key="card.title"
        :cols="prepareCols(index, selectedMenu ? selectedMenu.Menus.filter(x => !x.HideMobile).length : menus.filter(x => !x.HideMobile).length)"
        style="padding:15px;"
      >
        <card-button
          :ID="card.ID"
          :card="card"
          :image="card.Image"
          :bgColor="card.BGColor"
          :textColor="card.TextColor"
          :onSelectMenu="handleSelectMenu"
          :fontSize="card.FontSize"
          :font="card.Font"
          :text="getTranslation(card.Name, locale, card.TextFormat)" 
        />

      </v-col>
      <v-col
        v-if="back && !selectedMenu"
        cols="12"
      >
        <v-btn
          block
          outlined
          :color="config.ColorContent"
          style="height: 50px;"
          @click="handleBackDomain"
        >
          {{$t('common.back', locale)}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import utils from '@/services/utils'
import statsService from '@/services/stats'
import DishOrdersCart from '@/views/private/dishOrders/dishOrdersCart/Index'
import MainMenuHeader from './MainMenuHeader'
import CustomContent from '../../mobile/customMenu/CustomContent'
import AllergensFilter from '../../mobile/customMenu/items/foodDrink/AllergensFilter'
import SelectLocale from './SelectLocale'
import CardButton from './CardButton'
export default {
  components: {
    MainMenuHeader,
    CustomContent,
    DishOrdersCart,
    SelectLocale,
    AllergensFilter,
    CardButton,
  },
  props: {
    domain: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: null
    },
    isTotem: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedMenu: null, 
    backs: [],
    config: null,
    prominent: false,
    barNoImage: false,
  }),
  computed: {
    ...mapState('app',['menus']),
    emptyImage () {
      return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxVoqgnYQcchQneyiIrrVKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi6uKk6CIl/i8ptIj14Lgf7+497t4BQr3MNKsrBmi6baYScTGTXRV7XtGLAIKYxYDMLGNOkpLoOL7u4ePrXZRndT735+hTcxYDfCJxjBmmTbxBPL1pG5z3icOsKKvE58TjJl2Q+JHrisdvnAsuCzwzbKZT88RhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C0M5fWWZ6zRHkMAiliBBhIIqSijDRpRWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIoDnS/OM7HKNCzCzRqjvN97DiNE8D/DFzpLX+lDsx8kl5raZEjoH8buLhuacoecLkDDD0Zsim7kp+mkM8D72f0TVlg8BYIrnm9Nfdx+gCkqavkDXBwCIwVKHu9w7sD7b39e6bZ3w+aBHK2G7iMhgAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+cJCAo6GUNkOGsAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAEElEQVQIHQEFAPr/AAAAAAAABQABuokQigAAAABJRU5ErkJggg=="
    },
    path () {
      return this.$route.query.path && this.$route.query.path !== undefined ? this.$route.query.path : null
    },
    back () {
      return this.$route.query.back && this.$route.query.back !== undefined ? this.$route.query.back : null
    },
    backPath () {
      return this.$route.query.backPath && this.$route.query.backPath !== undefined ? this.$route.query.backPath : null
    },
    allergenFilters () {
      return this.$store.state.app.allergenFilters ? true : false
    },
    onlyContent () {
      return this.$route.query.onlyContent && this.$route.query.onlyContent !== undefined ? true : false
    },
    width () {
      if (this.isDesktop) return `${utils.getWidthPaddingDiff(this.sizeW, 0)}px !important`
      return '100% !important'
    },
    sizeW () {
      return window.innerWidth - (!utils.isMobile() ? 360 : 0)
    }
  },
  watch: {
    domain () {
      this.getEnterprise()
      //this.handleGetMenus()
    },
    '$route.query.path' () {
      if (this.path) this.getEnterprise()
    }
  },
  mounted () {
    this.getEnterprise()
    //this.handleGetMenus()
  },
  methods: {
    checkIsMenuColor (v, barNoImage) {
      if (barNoImage) return true
      return !v.Image || v.IsMenuWithSubmenu ? true : false
    },
    getTranslation (v, locale, textFormat, split) {
      let aux =utils.getTranslation(v, locale)
      if (split && aux.length > 10) {
        aux = aux.substring(0, 10) + '...'
      }
      return textFormat === 1 ? aux.toUpperCase() : textFormat === 2 ? aux.toLowerCase() : aux
    },
    prepareBreadcrumbs(selectedMenu, locale) {
      const aux = [{
        ID: null,
        Name: 'Home',
      }]
      if (this.backs) {
        for (const back of this.backs) {
          aux.push({
            ID: back.ID,
            Name: this.getTranslation(back.Name, locale, 1, true)
          })
        }
      }
      aux.push({
        ID: selectedMenu.ID,
        Name: this.getTranslation(selectedMenu.Name, locale, 1, true)
      })
      return aux
    },
    prepareCols (index, count) {
      if (count === 2) return 6
      if ((index + 1) === count && ((index + 1) % 3 !== 0)) return 12 // if last and only exist 1 of 2
      return index % 3 === 0 ? 4 : 2
    },
    getEnterprise () {
      const auxID = this.ID ? this.ID : this.domain
      if (auxID) {
        const aux = this.$route.query.c ? `?public=true&c=${this.$route.query.c}` : !this.isSimulation ? '?public=true' : ''          
        api.getItem('enterprises', false, auxID.concat(aux)).then(response => {
          this.config = response
          this.prominent = this.config.DesignByCardsProminent ? true : false
          this.barNoImage = this.config.DesignByCardsBarNoImage ? true : false
          this.handleGetMenus()
        })
      }
    },
    prepareColor (v, v2) {
      return v ? v : v2
    },
    handleGetMenus () {
          let auxID = this.isCommonMenus ? '0000' : this.ID ? this.ID : this.domain
          // se añade el id de usuario para los menús comunes poder filtrar por ellos
          auxID = `${auxID}/${this.isAdmin ? '' : this.$store.state.app.userID}`
          if (auxID) {
            api.getAll(`menus`, false, null, null, null, auxID).then(response => {
              response = response.filter(x => !x.HideMobile).map(item => {
                item.BGColor = this.prepareColor(item.BGColor, this.config.BGColor)
                item.TextColor = this.prepareColor(item.TextColor, this.config.Color)
                item.BGColorContent = this.prepareColor(item.BGColorContent, this.config.BGColorContent)
                item.FontSize = this.config.FontSize
                item.Font = this.config.Font
                item.TextFormat = this.config.TextFormat
                if (item.Menus) {
                  item.Menus = item.Menus.map (submenu => {
                    submenu.BGColor = this.prepareColor(submenu.BGColor, this.config.BGColorSecundary)
                    submenu.TextColor = this.prepareColor(submenu.TextColor, this.config.ColorSecundary)
                    submenu.BGColorContent = this.prepareColor(submenu.BGColorContent, this.config.BGColorContent)
                    submenu.FontSize = this.config.FontSizeSecundary
                    submenu.Font = this.config.FontSecundary
                    submenu.TextFormat = this.config.TextFormatSecundary
                    //submenu.Image = 'https://cdn.vuetifyjs.com/images/cards/house.jpg'
                    submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
                    if (submenu.Common && submenu.Availability.status) {
                      const {date, time} = submenu.Availability.status
                        submenu.IsActive = date && time ? true : false
                    }
                    return submenu
                  })
                  item.Menus = item.Menus.filter(x => !x.HideMobile && x.Availability.status.time && x.Availability.status.date)
                }
                item.Availability = utils.checkAvailabilityStatus(item.Availability)
                if (item.Common && item.Availability.status) {
                  const {date, time} = item.Availability.status
                    item.IsActive = date && time ? true : false
                }
                return item
              })

              response = response.filter(x => x.Availability && x.Availability.status.time && x.Availability.status.date)
              if (!this.isSimulation && this.$store.state.app.authType !== 'none' && !this.$store.state.app.authData) {                
                // this.$store.state.app.menus = response.filter(x => !x.Private && x.IsActive)
                this.$store.state.app.menus = response.filter(x => !x.Private)
              } else {
                this.$store.state.app.menus = response
              }              

              // Avoids double loading by the query "path"
              if (!this.selectedMenu || this.selectedMenu.ID !== this.path)this.prepareMenusByPath(this.path)
            })
            // this.$store.state.app.menus = []
          } else {
            this.$router.push('/404')
          }
    },
    prepareMenusByPath (v) {

      this.backs = []
      this.selectedMenu = null
      if(!v) {
        return
      }
      for (const menu of this.menus) {
        if (menu.ID === v) this.handleSelectMenu(menu)
        if (menu.Menus) {
          for (const submenu of menu.Menus) {
            if (submenu.ID === v) {
              this.selectedMenu = menu
              this.handleSelectMenu(submenu)
            }
          }
        }
      }
    },
    handleSelectMenu (v) {
      this.handleSetStats(v.ID)
      if (v.WebAppAsContent) {
        let url
        if (v.WebAppAsLink) url = v.WebAppAsContentDomain.split('@#@').join('?')
        else {
          url = `https://${v.WebAppAsContentDomain}.dtouch.es/#/`

          if (this.selectedMenu) {
            url += url.indexOf('?') >= 0 ? `&backPath=${this.selectedMenu.ID}&back=${this.config.Domain}` : `?backPath=${this.selectedMenu.ID}&back=${this.config.Domain}`
          } else {

            url += url.indexOf('?') >= 0 ? `&back=${this.config.Domain}` : `?back=${this.config.Domain}`
          }
        }
        window.location = url

        return
      }
      if (this.selectedMenu) this.backs.push(this.selectedMenu)
      //if (v.Menus)this.backs.push(v)
      this.selectedMenu = v
      this.handleChangeQuery(v)
      window.scrollTo(0, 0)
    },
    handleSetStats (menu) {
      // añadimos los registros de accesos públicos
      if (this.isTotem) {
        statsService.addStat({ WorkspaceID: this.config.ID, MenuID: menu.ID, Locale: this.$store.state.app.locale })
      } else {
        api.setStats('stats', menu)
      }
    },
    handleChangeQuery (v) {
      const query = Object.assign({}, this.$router.currentRoute.query)
      if (!v) {
        delete query.path
      } else {
        query.path = v.ID
      }
      this.$router.replace({ query })
      //this.$router.push({ path: '/point', query })
    },
    handleBack () {
      const aux = this.backs.pop()
      this.handleChangeQuery(aux)
      this.selectedMenu = aux
    },
    handleBackDomain () {
      let url = `${window.location.protocol}//${this.back}.${process.env.VUE_APP_API_URL}`
      url += '#/?'
      if (this.backPath) url += `&path=${this.backPath}`
      window.location.href = url
    },
  },
}
</script>
<style scoped>
.shadow-card-header {
  /*
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 1)) !important;
  */
background: linear-gradient(0deg, black, transparent 50%) bottom;
}
</style>

